import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Embeds Cal.com public booking UI for a host username and event slug.
 * Uses the hosted booking page (no Cal OAuth required inside the iframe).
 * For full @calcom/atoms OAuth refresh integration, replace with CalOAuthProvider + Booker when refreshUrl auth is aligned with your API.
 */
export default function CalcomBookerDialog({ open, onClose, username, eventSlug }) {
  const slug = eventSlug && String(eventSlug).trim() ? String(eventSlug).trim() : '';
  const user = username && String(username).trim() ? String(username).trim() : '';
  const src = user && slug
    ? `https://app.cal.com/${encodeURIComponent(user)}/${encodeURIComponent(slug)}`
    : '';

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" scroll="paper" sx={{ zIndex: 100000 }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
        <span>Schedule</span>
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, minHeight: 520 }}>
        {src ? (
          <Box sx={{ width: '100%', height: { xs: 480, sm: 560 }, lineHeight: 0 }}>
            <iframe
              title="Cal.com booking"
              src={src}
              style={{ width: '100%', height: '100%', border: 'none' }}
              allow="camera; microphone; payment"
            />
          </Box>
        ) : (
          <Box sx={{ p: 2 }}>Missing Cal.com username or event type slug for this booking link.</Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
